<template>
  <base-section
    id="features"
    class="secondary"
  >
    <v-responsive
      class="mx-auto"
      max-width="1350"
    >
      <v-container fluid>
        <v-row>
          <v-col
            v-for="card in cards"
            :key="card.title"
            cols="12"
            sm="4"
            md="3"
          >
            <base-info-card
              align="center"
              dark
              v-bind="card"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-responsive>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionFeatures',

    data: () => ({
      cards: [
        {
          icon: 'mdi-keyboard-outline',
          title: 'Truro Committees',
          text: 'Select Board appointed Committees',
          html: '<a href="https://www.truro-ma.gov/energy-committee" target="_page2">Energy</a><br><a href="https://www.truro-ma.gov/climate-action-committee" target="_page2">Climate Action</a><br><a href="https://www.truro-ma.gov/water-resources-oversight-committee" target="_page2">Water Resources Oversight</a><br><a href="https://www.truro-ma.gov/local-comprehensive-plan-committee" target="_page2">Local Comprehensive Plan</a>',
        },
        {
          icon: 'mdi-camera-outline',
          title: 'Truro Organizations',
          text: 'Non-profits in Truro',
          html: '<a href="http://truroconservationtrust.org/?page_id=24" target="_page2">Truro Conservation Trust</a>',
        },
        {
          icon: 'mdi-pencil-outline',
          title: 'Outer Cape',
          text: 'Organizations on the Outer Cape',
          html: '<a href="http://wellfleetenergyandclimateaction.org/" target="_page2">Wellfleet Energy & Climate Action Committee</a>',
        },
        {
          icon: 'mdi-puzzle-outline',
          title: 'State and Beyond',
          text: 'Organizations related to our Mission',
          html: '<a href="https://capecodclimate.org/" target="_page2">Cape Cod Climate Change Collaborative</a><br><a href="http://www.climatenetwork.org/" target="_page2">Climate Action Network International</a>',
        },
      ],
    }),
  }
</script>
